'use client';

import { useState } from 'react';
import Link from 'next/link';
import { Layers } from 'lucide-react';
import { LazyImage } from '@/components/LazyImage';

export interface ThemeCardProps {
  title: string;
  slug: string;
  image?: string;
  description: string;
}

export function ThemeCard({ title, slug, image, description }: ThemeCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link href={`/themes/${slug}`} className="h-full">
      <div
        className="group relative bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl cursor-pointer h-full flex flex-col"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Image */}
        <div className="relative overflow-hidden bg-gray-50">
          <LazyImage
            src={image || ''}
            alt={title}
            aspectRatio="3/2"
            className={`w-full h-[240px] ${isHovered ? 'scale-105 transition-transform duration-500' : ''}`}
            objectFit="cover"
            fallback={
              <div className="flex items-center justify-center bg-gradient-to-br from-indigo-50 to-purple-100 h-[240px]">
                <Layers className="w-12 h-12 text-indigo-300" />
              </div>
            }
          />
        </div>

        {/* Body */}
        <div className="p-5 flex-1">
          <h3 className="text-[17px] leading-tight font-bold text-gray-900 line-clamp-2 group-hover:text-blue-600 transition-colors mb-2">
            {title}
          </h3>
          <p className="text-sm text-gray-600 line-clamp-2">{description}</p>
        </div>
      </div>
    </Link>
  );
}
